import { render, staticRenderFns } from "./MixPay.vue?vue&type=template&id=109952aa&scoped=true&"
import script from "./MixPay.vue?vue&type=script&lang=js&"
export * from "./MixPay.vue?vue&type=script&lang=js&"
import style0 from "./MixPay.vue?vue&type=style&index=0&id=109952aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109952aa",
  null
  
)

export default component.exports